import { useEffect, useState } from "react";
import { isMobile, isTablet } from "react-device-detect";
import SampleCard from "./SampleCard";
import styled from "styled-components";
import { AppColors } from '../../../Global/StyledComponents/Graphics';
import supabase from "../../../Controllers/utils/supabaseClient";

const SampleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-bottom: ${(!isMobile || isTablet) ? 0 : '20px'};
`;

const SampleGrid = styled.div`
    display: grid;
    grid-template-columns: ${(!isMobile || isTablet) ? 'repeat(3, auto)' : '1fr'};
    max-width: 100%;
    height: auto;
    justify-content: center;
    gap: ${(!isMobile || isTablet) ? '0' : '10px'};
`;

const SampleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: ${(!isMobile || isTablet) ? '60%' : '85%'};
    flex-shrink: 0;
    height: ${(!isMobile || isTablet) ? 'auto' : null};
    padding: ${(!isMobile || isTablet) ? '20px' : '0 0 40px 0'};
    box-sizing: border-box;
    overflow: ${(!isMobile || isTablet) ? 'auto' : 'hidden'};
`;

const Heading = styled.h1`
    color: ${AppColors.MRGREEN};
    font-size: 36px;
    font-family: 'Poppins', Arial, Helvetica, sans-serif;
    font-weight: 600;
`;

const SubHeading = styled.p`
    color: white;
    font-size: 18px;
    max-width: 80%;
    margin: 10px;
`;

const StyledLink = styled.a`
    color: ${AppColors.MRGREEN};
    font-size: 18px;
`;

const SampleView = ({ readOnly, trialPage }) => {
    const [samples, setSamples] = useState([]);

    useEffect(() => {
        supabase.from('sample_cards').select('*').then(res => {
            if (res?.data?.length) {
                const data = res?.data;

                setSamples(() => (
                    (isMobile && !isTablet) ? data.slice(0, 4) :
                    data.slice(0, 6)
                ));
            }
        });
    }, []);

    return (
        <SampleWrapper>
            <SampleContainer>
                <Heading>
                    The Market Analyst In Your Pocket
                </Heading>
                <SubHeading>
                    Institutional-Grade Coverage Of Every Asset On Your Watchlist
                </SubHeading>
                <SampleGrid>
                    {samples?.map((sampleData) => (
                        <SampleCard data={sampleData} readOnly={readOnly} />
                    ))}
                </SampleGrid>
                <SubHeading style={{ fontSize: '22px', fontWeight: 'bold' }}>
                    Save Time with Comprehensive, Noise-Free Market Insights
                </SubHeading>
                <SubHeading>
                    MarketReader generates concise explanations of what is moving in the market and why, allowing you to quickly get up to speed and spend more time on what matters to you. 
                </SubHeading>
                {trialPage &&
                    <SubHeading>
                        Request a trial today to get access to timely, comprehensive and easily digestible summaries of the drivers of price action across every US-listed equity asset. 
                    </SubHeading>
                }
                <br/>
                <StyledLink href="https://marketreader.com/technology/" target="blank">
                        Learn More
                </StyledLink> 
            </SampleContainer>
        </SampleWrapper>
    );
};

export default SampleView;
